export enum ProcessingType {
  /**
   * The processing type is not yet known, possibly because no process plan has been assigned.
   */
  UNKNOWN = 'UNKNOWN',

  /**
   * The WorkItem has to be produced.
   */
  PRODUCED = 'PRODUCED',

  /**
   * The WorkItem is commissioned and does not have to be produced.
   */
  PICKING = 'PICKING',
}

export class ProcessingTypeUtil {
  public static supportsConsumptionAndFinished(type: ProcessingType): boolean {
    switch (type) {
      case ProcessingType.UNKNOWN:
        return false
      case ProcessingType.PICKING:
        return false
      case ProcessingType.PRODUCED:
        return true
    }
  }
}
